import { get as _get } from 'lodash';

import rolePermissionMap from '../permissionMap';

const hasPermission = (permission, role) => _get(rolePermissionMap, permission, []).includes(role);

export default hasPermission;
